export const flattenObject = (
  obj: Record<string, any>,
  parent: string = ''
): Record<string, any> => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const path = `${parent ? parent + ':' : ''}${key}`;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(acc, flattenObject(value, path));
    } else {
      acc[path] = value;
    }
    return acc;
  }, {} as Record<string, any>);
};
